import React from 'react'
import PropTypes from 'prop-types'

import { StyledHexInput } from './styled'

const HexInput = ({ value, setExampleColor }) => {
	const handleHexChange = event => {
		setExampleColor(event.target.value)
	}

	return (
		<StyledHexInput type={'text'} value={!value ? '#' : value.toUpperCase()} onChange={handleHexChange}/>
	)
}

HexInput.propTypes = {
	value: PropTypes.string,
	setExampleColor: PropTypes.func
}

export default HexInput
